import React from "react";
import UserScreenWindow from "../Components/UserScreenWindow";

function CleaningServicesUser() {
  return (
    <UserScreenWindow label="Cleaning Services">
      CleaningServicesUser
    </UserScreenWindow>
  );
}

export default CleaningServicesUser;
